import gradientClasses from './styles.module.sass';
import Preview from '../Preview/Preview';
import gradientPreview from './preview.png';
import { ReactComponent as GradientBackButton } from './svg/back-button.svg';
import { ReactComponent as GradientTogglePlay } from './svg/toggle-play.svg';
import { ReactComponent as GradientTogglePause } from './svg/toggle-pause.svg';
import { ReactComponent as GradientPlay } from './svg/play.svg';
import { ReactComponent as GradientSpeed } from './svg/speed.svg';
import { ReactComponent as GradientFullscreenEnter } from './svg/fullscreen-enter.svg';
import { ReactComponent as GradientFullscreenExit } from './svg/fullscreen-exit.svg';
import { ReactComponent as GradientVolume } from './svg/volume.svg';
import { ReactComponent as GradientVolumeMuted } from './svg/volume-muted.svg';
import { ReactComponent as GradientChapters } from './svg/chapters.svg';
import { ReactComponent as GradientQuality } from './svg/quality.svg';
import { ReactComponent as GradientSubtitles } from './svg/subtitles.svg';
import { getBgColor } from '../../../WithBackgroundColor/WithBackgroundColor';
import { IPlayerSkin } from '../types';

// #8
export const gradientSkin: IPlayerSkin = {
  key: 'gradient',
  label: 'Gradient',
  classes: gradientClasses,
  component: Preview,
  preview: gradientPreview,
  handles: true,
  handleValue: false,
  tips: true,
  icons: {
    backButton: GradientBackButton,
    togglePlay: GradientTogglePlay,
    togglePause: GradientTogglePause,
    play: GradientPlay,
    speed: GradientSpeed,
    fullscreenEnter: GradientFullscreenEnter,
    fullscreenExit: GradientFullscreenExit,
    quality: GradientQuality,
    volume: GradientVolume,
    volumeMuted: GradientVolumeMuted,
    chapters: GradientChapters,
    subtitles: GradientSubtitles,
  },
  bgColors: {
    controls__popover: () => '#fff',
    volume__trackBg: getBgColor,
    volume__bar: getBgColor,
    progressBar__bar: getBgColor,
    progressBar__handle: getBgColor,
    progressBar__previews: getBgColor,
  },
  colors: {
    // backButton: getBgColor, No need the color here because the arrow just white
    controls__popoverTip: () => '#fff',
    controls__popover: () => 'rgb(51, 51, 51)',
    progressBar__handle: getBgColor, // for shadow around handler
  },
  approximateBarHeight: 52,
};
